import { InsightsFeature, ViewerFeature } from './types';

export enum FormTypes {
  Assembly = 'ASSEMBLY',
  PaintBlocks = 'PAINT_BLOCKS',
  PointOfInterest = 'POINT_OF_INTEREST',
  Structure = 'STRUCTURE',
  DefectLegends = 'DEFECT_LEGENDS',
  QuerySummary = 'QUERY_SUMMARY',
  RiskConfiguration = 'RISK_CONFIGURATION',
}

export enum StructureSection {
  StructureDetails = 'structure-details',
  Features = 'features',
  ReportConfig = 'report-config',
}

export const INSIGHTS_OPTIONS: { label: string; key: InsightsFeature }[] = [
  { label: 'Components Tab', key: 'COMPONENTS_TAB' },
  { label: 'POI Tab', key: 'POINTS_OF_INTEREST_TAB' },
  { label: 'Paint Block Tab', key: 'PAINT_BLOCK_TAB' },
  { label: 'Decks Tab', key: 'DECK_TAB' },
];

export const VIEWER_OPTIONS: { label: string; key: ViewerFeature }[] = [
  { label: 'Deck Filter', key: 'DECK_FILTER' },
  { label: 'Paint Block Filter', key: 'PAINT_BLOCK_FILTER' },
];

export const REPORT_CONFIG_KEYS: string[] = [
  'poi-name',
  'workpack-number',
  'is-verified',
  'paint-block',
  'deck',
  'poi-type',
  'accessibility',
];
